import { render, staticRenderFns } from "./DocumentModal.vue?vue&type=template&id=f6cf1e64&scoped=true&"
import script from "./DocumentModal.vue?vue&type=script&lang=js&"
export * from "./DocumentModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentModal.vue?vue&type=style&index=0&id=f6cf1e64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cf1e64",
  null
  
)

export default component.exports